__turbopack_context__.v({
  "accordion": "PlasmicHomepage-module__rrZLOW__accordion",
  "accordionItem___4ISpm": "PlasmicHomepage-module__rrZLOW__accordionItem___4ISpm",
  "accordionItem__aSf1N": "PlasmicHomepage-module__rrZLOW__accordionItem__aSf1N",
  "accordionItem__ksf6Q": "PlasmicHomepage-module__rrZLOW__accordionItem__ksf6Q",
  "accordionItem__nx4Ny": "PlasmicHomepage-module__rrZLOW__accordionItem__nx4Ny",
  "accordionItem__t7AYg": "PlasmicHomepage-module__rrZLOW__accordionItem__t7AYg",
  "backToTop": "PlasmicHomepage-module__rrZLOW__backToTop",
  "button__qjaW6": "PlasmicHomepage-module__rrZLOW__button__qjaW6",
  "button__r68Ie": "PlasmicHomepage-module__rrZLOW__button__r68Ie",
  "button__uIlNv": "PlasmicHomepage-module__rrZLOW__button__uIlNv",
  "button__uaW63": "PlasmicHomepage-module__rrZLOW__button__uaW63",
  "button__zdgEz": "PlasmicHomepage-module__rrZLOW__button__zdgEz",
  "faq": "PlasmicHomepage-module__rrZLOW__faq",
  "footer": "PlasmicHomepage-module__rrZLOW__footer",
  "freeBox___19LSm": "PlasmicHomepage-module__rrZLOW__freeBox___19LSm",
  "freeBox___3KV26": "PlasmicHomepage-module__rrZLOW__freeBox___3KV26",
  "freeBox___5UFwc": "PlasmicHomepage-module__rrZLOW__freeBox___5UFwc",
  "freeBox___6Hn0C": "PlasmicHomepage-module__rrZLOW__freeBox___6Hn0C",
  "freeBox___6P4T": "PlasmicHomepage-module__rrZLOW__freeBox___6P4T",
  "freeBox___73EGw": "PlasmicHomepage-module__rrZLOW__freeBox___73EGw",
  "freeBox__coV4R": "PlasmicHomepage-module__rrZLOW__freeBox__coV4R",
  "freeBox__dt8NZ": "PlasmicHomepage-module__rrZLOW__freeBox__dt8NZ",
  "freeBox__fJqtq": "PlasmicHomepage-module__rrZLOW__freeBox__fJqtq",
  "freeBox__fys94": "PlasmicHomepage-module__rrZLOW__freeBox__fys94",
  "freeBox__grnnj": "PlasmicHomepage-module__rrZLOW__freeBox__grnnj",
  "freeBox__gwptl": "PlasmicHomepage-module__rrZLOW__freeBox__gwptl",
  "freeBox__h3Eq8": "PlasmicHomepage-module__rrZLOW__freeBox__h3Eq8",
  "freeBox__hgrDk": "PlasmicHomepage-module__rrZLOW__freeBox__hgrDk",
  "freeBox__jxkc8": "PlasmicHomepage-module__rrZLOW__freeBox__jxkc8",
  "freeBox__l5XRa": "PlasmicHomepage-module__rrZLOW__freeBox__l5XRa",
  "freeBox__lGwEm": "PlasmicHomepage-module__rrZLOW__freeBox__lGwEm",
  "freeBox__lRuE6": "PlasmicHomepage-module__rrZLOW__freeBox__lRuE6",
  "freeBox__lmXnu": "PlasmicHomepage-module__rrZLOW__freeBox__lmXnu",
  "freeBox__n1Xx8": "PlasmicHomepage-module__rrZLOW__freeBox__n1Xx8",
  "freeBox__nwCvB": "PlasmicHomepage-module__rrZLOW__freeBox__nwCvB",
  "freeBox__oA15": "PlasmicHomepage-module__rrZLOW__freeBox__oA15",
  "freeBox__oXknl": "PlasmicHomepage-module__rrZLOW__freeBox__oXknl",
  "freeBox__oiLlr": "PlasmicHomepage-module__rrZLOW__freeBox__oiLlr",
  "freeBox__pZV9": "PlasmicHomepage-module__rrZLOW__freeBox__pZV9",
  "freeBox__pdyBi": "PlasmicHomepage-module__rrZLOW__freeBox__pdyBi",
  "freeBox__q71Wz": "PlasmicHomepage-module__rrZLOW__freeBox__q71Wz",
  "freeBox__qDp3": "PlasmicHomepage-module__rrZLOW__freeBox__qDp3",
  "freeBox__rjeTk": "PlasmicHomepage-module__rrZLOW__freeBox__rjeTk",
  "freeBox__thfjv": "PlasmicHomepage-module__rrZLOW__freeBox__thfjv",
  "freeBox__tiz6H": "PlasmicHomepage-module__rrZLOW__freeBox__tiz6H",
  "freeBox__vJvnQ": "PlasmicHomepage-module__rrZLOW__freeBox__vJvnQ",
  "freeBox__wqrBk": "PlasmicHomepage-module__rrZLOW__freeBox__wqrBk",
  "freeBox__y6ACo": "PlasmicHomepage-module__rrZLOW__freeBox__y6ACo",
  "freeBox__y7DBr": "PlasmicHomepage-module__rrZLOW__freeBox__y7DBr",
  "freeBox__ygyRt": "PlasmicHomepage-module__rrZLOW__freeBox__ygyRt",
  "freeBox__zy3UP": "PlasmicHomepage-module__rrZLOW__freeBox__zy3UP",
  "header": "PlasmicHomepage-module__rrZLOW__header",
  "homePageWrapper": "PlasmicHomepage-module__rrZLOW__homePageWrapper",
  "img___2HlXl": "PlasmicHomepage-module__rrZLOW__img___2HlXl",
  "img___7HwUl": "PlasmicHomepage-module__rrZLOW__img___7HwUl",
  "img__got7T": "PlasmicHomepage-module__rrZLOW__img__got7T",
  "img__mqlR6": "PlasmicHomepage-module__rrZLOW__img__mqlR6",
  "img__otnYc": "PlasmicHomepage-module__rrZLOW__img__otnYc",
  "img__qj1DT": "PlasmicHomepage-module__rrZLOW__img__qj1DT",
  "img__rrQ99": "PlasmicHomepage-module__rrZLOW__img__rrQ99",
  "img__sLb3C": "PlasmicHomepage-module__rrZLOW__img__sLb3C",
  "img__wFag": "PlasmicHomepage-module__rrZLOW__img__wFag",
  "img__xcWYr": "PlasmicHomepage-module__rrZLOW__img__xcWYr",
  "lgPresetMessage": "PlasmicHomepage-module__rrZLOW__lgPresetMessage",
  "lgctaButton__ga0Y5": "PlasmicHomepage-module__rrZLOW__lgctaButton__ga0Y5",
  "lgctaButton__zKmDn": "PlasmicHomepage-module__rrZLOW__lgctaButton__zKmDn",
  "primaryButton__eytHu": "PlasmicHomepage-module__rrZLOW__primaryButton__eytHu",
  "primaryButton__w5U2C": "PlasmicHomepage-module__rrZLOW__primaryButton__w5U2C",
  "reviewCard": "PlasmicHomepage-module__rrZLOW__reviewCard",
  "reviewCard2": "PlasmicHomepage-module__rrZLOW__reviewCard2",
  "reviewCard3": "PlasmicHomepage-module__rrZLOW__reviewCard3",
  "reviewCard4": "PlasmicHomepage-module__rrZLOW__reviewCard4",
  "reviewCard5": "PlasmicHomepage-module__rrZLOW__reviewCard5",
  "reviewCard6": "PlasmicHomepage-module__rrZLOW__reviewCard6",
  "reviewSlide": "PlasmicHomepage-module__rrZLOW__reviewSlide",
  "reviewSlide2": "PlasmicHomepage-module__rrZLOW__reviewSlide2",
  "reviewSlide3": "PlasmicHomepage-module__rrZLOW__reviewSlide3",
  "reviews": "PlasmicHomepage-module__rrZLOW__reviews",
  "slider": "PlasmicHomepage-module__rrZLOW__slider",
  "sliderBtn__dxZ9E": "PlasmicHomepage-module__rrZLOW__sliderBtn__dxZ9E",
  "sliderBtn__fbd5Y": "PlasmicHomepage-module__rrZLOW__sliderBtn__fbd5Y",
  "sliderBtn__mlCls": "PlasmicHomepage-module__rrZLOW__sliderBtn__mlCls",
  "sliderCarousel": "PlasmicHomepage-module__rrZLOW__sliderCarousel",
  "sliderThumb__sDl9": "PlasmicHomepage-module__rrZLOW__sliderThumb__sDl9",
  "svg__aeHfx": "PlasmicHomepage-module__rrZLOW__svg__aeHfx",
  "svg__c7Jno": "PlasmicHomepage-module__rrZLOW__svg__c7Jno",
  "svg__dKb6Q": "PlasmicHomepage-module__rrZLOW__svg__dKb6Q",
  "svg__fUBr5": "PlasmicHomepage-module__rrZLOW__svg__fUBr5",
  "svg__frX0K": "PlasmicHomepage-module__rrZLOW__svg__frX0K",
  "svg__hrkef": "PlasmicHomepage-module__rrZLOW__svg__hrkef",
  "svg__jm3Ov": "PlasmicHomepage-module__rrZLOW__svg__jm3Ov",
  "svg__kfSo5": "PlasmicHomepage-module__rrZLOW__svg__kfSo5",
  "svg__ks2Ka": "PlasmicHomepage-module__rrZLOW__svg__ks2Ka",
  "svg__mrcSa": "PlasmicHomepage-module__rrZLOW__svg__mrcSa",
  "svg__pv3U6": "PlasmicHomepage-module__rrZLOW__svg__pv3U6",
  "svg__t2Qq2": "PlasmicHomepage-module__rrZLOW__svg__t2Qq2",
  "svg__v3Br": "PlasmicHomepage-module__rrZLOW__svg__v3Br",
  "svg__wPl0L": "PlasmicHomepage-module__rrZLOW__svg__wPl0L",
  "svg__z7HPx": "PlasmicHomepage-module__rrZLOW__svg__z7HPx",
  "text___1YaGi": "PlasmicHomepage-module__rrZLOW__text___1YaGi",
  "text___4LzZe": "PlasmicHomepage-module__rrZLOW__text___4LzZe",
  "text___5He8E": "PlasmicHomepage-module__rrZLOW__text___5He8E",
  "text___8FgbC": "PlasmicHomepage-module__rrZLOW__text___8FgbC",
  "text___97BmZ": "PlasmicHomepage-module__rrZLOW__text___97BmZ",
  "text___9BMzq": "PlasmicHomepage-module__rrZLOW__text___9BMzq",
  "text___9DmS": "PlasmicHomepage-module__rrZLOW__text___9DmS",
  "text___9TaqQ": "PlasmicHomepage-module__rrZLOW__text___9TaqQ",
  "text___9TdnJ": "PlasmicHomepage-module__rrZLOW__text___9TdnJ",
  "text__avAz0": "PlasmicHomepage-module__rrZLOW__text__avAz0",
  "text__cW2UX": "PlasmicHomepage-module__rrZLOW__text__cW2UX",
  "text__cn2Eb": "PlasmicHomepage-module__rrZLOW__text__cn2Eb",
  "text__fRsjD": "PlasmicHomepage-module__rrZLOW__text__fRsjD",
  "text__fyk4A": "PlasmicHomepage-module__rrZLOW__text__fyk4A",
  "text__fz7Qq": "PlasmicHomepage-module__rrZLOW__text__fz7Qq",
  "text__gDv": "PlasmicHomepage-module__rrZLOW__text__gDv",
  "text__gn4Q6": "PlasmicHomepage-module__rrZLOW__text__gn4Q6",
  "text__hHegW": "PlasmicHomepage-module__rrZLOW__text__hHegW",
  "text__hJHw": "PlasmicHomepage-module__rrZLOW__text__hJHw",
  "text__hnvSw": "PlasmicHomepage-module__rrZLOW__text__hnvSw",
  "text__iCMmM": "PlasmicHomepage-module__rrZLOW__text__iCMmM",
  "text__jwJ0I": "PlasmicHomepage-module__rrZLOW__text__jwJ0I",
  "text__kNmr4": "PlasmicHomepage-module__rrZLOW__text__kNmr4",
  "text__kn6Yc": "PlasmicHomepage-module__rrZLOW__text__kn6Yc",
  "text__n8SMg": "PlasmicHomepage-module__rrZLOW__text__n8SMg",
  "text__nf8Bc": "PlasmicHomepage-module__rrZLOW__text__nf8Bc",
  "text__njSsk": "PlasmicHomepage-module__rrZLOW__text__njSsk",
  "text__oLgHv": "PlasmicHomepage-module__rrZLOW__text__oLgHv",
  "text__pLdns": "PlasmicHomepage-module__rrZLOW__text__pLdns",
  "text__qvvwQ": "PlasmicHomepage-module__rrZLOW__text__qvvwQ",
  "text__rMds": "PlasmicHomepage-module__rrZLOW__text__rMds",
  "text__rkNo3": "PlasmicHomepage-module__rrZLOW__text__rkNo3",
  "text__stUfq": "PlasmicHomepage-module__rrZLOW__text__stUfq",
  "text__uKPux": "PlasmicHomepage-module__rrZLOW__text__uKPux",
  "text__wXbaF": "PlasmicHomepage-module__rrZLOW__text__wXbaF",
  "text__zQfY": "PlasmicHomepage-module__rrZLOW__text__zQfY",
  "text__zTpvP": "PlasmicHomepage-module__rrZLOW__text__zTpvP",
  "text__zx1Tj": "PlasmicHomepage-module__rrZLOW__text__zx1Tj",
});
